import { OrgId, OrgIds, Route } from "@today/api/tracker"

export function getRoutesOfOrg(orgId: OrgId, routes: Route[]) {
  return routes.filter((r) => {
    switch (orgId) {
      case OrgIds.kdlogistics:
        return r.regionSetName.startsWith("K")

      default:
        return true
    }
  })
}
